import { baseReportUrl } from 'environments'
import { createActions } from 'helpers/actions'
import entityNames from 'options/entityNames'

export default createActions(entityNames.assetProductAssetsReport, {
  basePath: 'report/assetReports',
  baseUrl: baseReportUrl,
})
